export default __webpack_public_path__ + "static/media/alethio2.77702290.png";